import 'css-chunksrc/client/common/elementAttachments/styles.scss';export default {
  "section": "_section_4toz1_1",
  "header": "_header_4toz1_7",
  "label": "_label_4toz1_16",
  "count": "_count_4toz1_25",
  "attachButton": "_attachButton_4toz1_36",
  "loaderContainer": "_loaderContainer_4toz1_51",
  "emptyDrop": "_emptyDrop_4toz1_58",
  "emptyText": "_emptyText_4toz1_68",
  "cards": "_cards_4toz1_73",
  "dropZone": "_dropZone_4toz1_82",
  "dropOverlay": "_dropOverlay_4toz1_86",
  "uploadLoader": "_uploadLoader_4toz1_98",
  "dropOverlayText": "_dropOverlayText_4toz1_109"
};